import getGDriveFileProviderItems from '../getFileProviderItems/getGDriveFileProviderItems';
import { GDRIVE_FILE_PICKER_FETCH_ITEMS_PARAMS } from '../constants';
import type SearchAttachmentDataProviderItemsResponse from 'owa-service/lib/contract/SearchAttachmentDataProviderItemsResponse';

export default async function searchGDriveFileProviderItems(
    query: string,
    currentFolder: string = ''
): Promise<SearchAttachmentDataProviderItemsResponse> {
    let searchItemsQuery: string = `${GDRIVE_FILE_PICKER_FETCH_ITEMS_PARAMS}&q=mimeType!='application/octet-stream' and trashed=false and fullText contains '${query}'`;

    if (currentFolder) {
        searchItemsQuery = `${searchItemsQuery} and '${currentFolder}' in parents`;
    }

    return getGDriveFileProviderItems(searchItemsQuery);
}
